import { useTranslation } from 'react-i18next';

export default function Hero({ setActiveTab }) {
  const { t } = useTranslation();

  return (
    <section className="min-h-[80vh] sm:min-h-screen flex items-center justify-center px-4 sm:px-6 py-16 sm:py-20">
      <div className="max-w-3xl text-center space-y-6 sm:space-y-8">
        <h1 className="text-4xl sm:text-6xl md:text-7xl font-light tracking-tight leading-tight">
          {t('hero.title')}
        </h1>
        <p className="text-lg sm:text-xl text-gray-600 font-light leading-relaxed">
          {t('hero.subtitle')}
        </p>
        <button
          onClick={() => setActiveTab('member')}
          className="mt-6 sm:mt-8 px-6 sm:px-8 py-3 bg-gray-900 text-white text-sm font-light tracking-wide rounded-md hover:bg-gray-800 transition-colors"
        >
          {t('hero.join')}
        </button>
      </div>
    </section>
  );
}